import RolloutSampleStatus from './RolloutSampleStatus';

export default class RolloutSampleStatusDTO {

    public physicalSampleId: number;
    public macAddress: string;
    public rolloutId: number;
    public targetReleaseVersion: string;
    public currentStatus: RolloutSampleStatus;
    public currentErrorMessage?: string;
    public pilot: boolean;
    public startedAt?: string;
    public finishedAt?: string;
    public lastTransitionAt?: string;

    constructor(data: { [key: string]: any }) {
        this.physicalSampleId = data['physicalSampleId'];
        this.macAddress = data['macAddress'];
        this.rolloutId = data['rolloutId'];
        this.targetReleaseVersion = data['targetReleaseVersion'];
        this.currentStatus = data['currentStatus'];
        this.currentErrorMessage = data['currentErrorMessage'];
        this.pilot = data['pilot'];
        this.startedAt = data['startedAt'];
        this.finishedAt = data['finishedAt'];
        this.lastTransitionAt = data['lastTransitionAt'];
    }
}
